/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';

interface Freshpaint {
  get_property?: (property: string) => string | undefined;
  get_distinct_id?: () => string | undefined;
}

declare global {
  interface Window {
    freshpaint?: Freshpaint;
  }
}

interface FactuaPopupProps {
  show: boolean;
  onClose: () => void;
  iframeLink: string;
  defaultWidth?: number;
  defaultHeight?: number;
}

const Factua: React.FC<FactuaPopupProps> = ({
  show,
  onClose,
  iframeLink,
  defaultWidth = 800,
  defaultHeight = 396,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeSize, setIframeSize] = useState({
    width: defaultWidth,
    height: defaultHeight,
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleMessage = (event: MessageEvent): void => {
      if (event.data?.action === 'resizePopup') {
        setIframeSize({
          width: event.data.width,
          height: event.data.height,
        });
      }

      if (event.data?.action === 'IFRAME_REDIRECT') {
        window.location.href = `${event.origin}${event.data.path}`;
      }
      if (event.data?.action === 'MARKETING_SIDE_POPUP_CLOSE') {
        onClose();
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onClose]);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  const sendParentDomainAndFreshpaintDetails = (): void => {
    if (!iframeRef.current) return;
    iframeRef.current.contentWindow?.postMessage(
      { action: 'PARENT_DOMAIN', domain: window.location.host },
      '*'
    );

    if (typeof window !== 'undefined' && window.freshpaint) {
      const freshpaint = window.freshpaint;
      const data = {
        type: 'freshpaint_identity',
        device_id: freshpaint.get_property ? freshpaint.get_property('$device_id') : undefined,
        session_id: freshpaint.get_property ? freshpaint.get_property('$session_id') : undefined,
        distinct_id: freshpaint.get_distinct_id ? freshpaint.get_distinct_id() : undefined,
        utm_source: freshpaint.get_property ? freshpaint.get_property('utm_source') : undefined,
        utm_medium: freshpaint.get_property ? freshpaint.get_property('utm_medium') : undefined,
        utm_campaign: freshpaint.get_property ? freshpaint.get_property('utm_campaign') : undefined,
        utm_content: freshpaint.get_property ? freshpaint.get_property('utm_content') : undefined,
        utm_term: freshpaint.get_property ? freshpaint.get_property('utm_term') : undefined,
        referrer: freshpaint.get_property ? freshpaint.get_property('$referrer') : undefined,
        initial_referrer: freshpaint.get_property
          ? freshpaint.get_property('$initial_referrer')
          : undefined,
      };
      iframeRef.current.contentWindow?.postMessage(
        {
          action: 'FRESHPAINT_IDENTITY',
          data,
        },
        '*'
      );
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      sendParentDomainAndFreshpaintDetails();
    }, 200);

    return () => clearInterval(interval);
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        style={{
          width: iframeSize.width,
          height: iframeSize.height,
          borderRadius: '20px',
          backgroundColor: 'white',
          position: 'relative',
          overflow: 'hidden',
          transition: 'all 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
        }}
      >
        <button
          onClick={onClose}
          aria-label="Close popup"
          style={{
            position: 'absolute',
            top: 10,
            right: 12,
            width: 24,
            height: 24,
            background: 'transparent',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            outline: 'none',
          }}
        >
          <CloseIcon fontSize="small" style={{ color: '#0095A9' }} />
        </button>
        <iframe
          ref={iframeRef}
          src={iframeLink}
          title="Booking Flow"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block',
            flexShrink: 0,
          }}
          onLoad={sendParentDomainAndFreshpaintDetails}
        />
      </div>
    </div>
  );
};

export default Factua;
